/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

export interface MalwareAuditFixture {
  auditRun: string;
  type: string;
  summary: string;
  affectedPackages: number;
  affectedRepositories: number;
}

/** Illustrative only: the single audit the prototype shows. */
export const MALWARE_AUDIT_FIXTURE: MalwareAuditFixture = {
  auditRun: 'May 23, 2026, 8:00 AM',
  type: 'Daily',
  summary: '2 packages found in 4 repos',
  affectedPackages: 2,
  affectedRepositories: 4,
};

export const MALWARE_STATS = {
  malicious: 2,
  blocked: 0,
  protectedRequests: 0,
};

export interface MalwareEventFixture {
  packageName: string;
  repository: string;
  cve: string;
  cveUrl: string;
  discovered: string;
  status: string;
  resolved: string;
  resolvedBy: string;
}

export const MALWARE_EVENT_FIXTURE: MalwareEventFixture = {
  packageName: 'nuget/Contoso.Keylogger@4.1.0',
  repository: 'nuget-proxy-1',
  cve: 'CVE-2023-45139',
  cveUrl: 'https://guide.sonatype.com/vulnerability/CVE-2023-45139',
  discovered: 'May 8, 2026 9:14 AM',
  status: 'Quarantined',
  resolved: 'May 8, 2026 10:02 AM',
  resolvedBy: 'Jordan Lee',
};

export interface FilterOption {
  label: string;
  count: number;
}

export interface FilterGroup {
  title: string;
  options: FilterOption[];
}

export const MALWARE_EVENT_FILTERS: FilterGroup[] = [
  {
    title: 'Repository',
    options: [
      { label: 'maven-central-proxy', count: 1 },
      { label: 'npm-group-public', count: 1 },
      { label: 'npm-proxy-1', count: 2 },
      { label: 'nuget-proxy-1', count: 2 },
      { label: 'pypi-proxy-central', count: 2 },
    ],
  },
  {
    title: 'Status',
    options: [
      { label: 'Quarantined', count: 4 },
      { label: 'Removed', count: 4 },
    ],
  },
  {
    title: 'Resolved By',
    options: [
      { label: 'Alex Morgan', count: 2 },
      { label: 'Chris Nguyen', count: 2 },
      { label: 'Jordan Lee', count: 2 },
      { label: 'Samira Patel', count: 2 },
      { label: '—', count: 0 },
    ],
  },
];
